// Bootstrap Modules, jQuery and other Bootstrap dependencies provided by Webpack
import 'bootstrap'


import './modules/grid-content.js'
import './modules/filter.js'
import './modules/iframe.js'
import './modules/accordion-collapse.js'
import './modules/eurolandtoolsintegrationobject'
import './modules/cookie-bar'
import './modules/image-slider'
import './modules/mobile-menu-collapse'
import './modules/video-modal'
import './modules/faq'
import './modules/tabs-module'
import './modules/hero-slider'

import './partials/recipe-time.js'
import './partials/sub-nav.js'

import './pages/annual-report.js'
import './pages/brands-detail.js'
import './pages/faq.js'
import './pages/downloadcenter.js'
import './pages/single-recipes.js'
import './pages/single-quiz.js'
import './pages/sillkampen.js'
import './pages/archive-orklaway-documents.js'

import './layout/header.js'
import './layout/parallax.js'


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/index.js
// module id = 11
// module chunks = 0